import Vue from 'vue'
import Router from 'vue-router'

import Map from "../components/Map";
import ProducerRegistration from "../components/ProducerRegistration";
import LandingPageProducer from "../components/LandingPageProducer";
import Faq from "../components/Faq";
import HowTo from "../components/HowTo";
import WhoWeAre from "../components/WhoWeAre";
import NotFound from "../components/NotFound";
import Home from "../components/Home";

// When used with a module system, like vue-router, 
// you must explicitly install the router via Vue.use()
Vue.use(Router);

const DEFAULT_TAB_TITLE = 'Valle di Comino | ';



const router = new Router({
    mode: 'history',
    routes: [
        {
            path: "/",
            redirect: {
                name: "home"
            },
			meta: { title: DEFAULT_TAB_TITLE + 'Home' }
        },
        {
            path: "/home",
            name: "home",
            component: Home,
			meta: { title: DEFAULT_TAB_TITLE + 'Home' }
        },
        {
            path: "/mappa",
            name: "map",
            component: Map,
			meta: { title: DEFAULT_TAB_TITLE + 'Mappa' }
        },
        {
            path: "/azienda",
            name: "azienda",
            component: LandingPageProducer,
			meta: { title: DEFAULT_TAB_TITLE + 'Azienda' }
        },
        {
            path: "/registrati",
            name: "register",
            component: ProducerRegistration,
			meta: { title: DEFAULT_TAB_TITLE + 'Registrati' }
        },
        {
            path: "/domande-frequenti",
            name: "faq",
            component: Faq,
			meta: { title: DEFAULT_TAB_TITLE + 'FAQ' }
        },
        {
            path: "/come-funziona",
            name: "howto",
            component: HowTo,
			meta: { title: DEFAULT_TAB_TITLE + 'Come funziona' }
        },
        {
            path: "/la-valle",
            name: "la-valle",
            component: WhoWeAre,
			meta: { title: DEFAULT_TAB_TITLE + 'La valle' }
        },
        {
			path: '*', 
			component: NotFound, 
			meta: { title: DEFAULT_TAB_TITLE + 'Not Found' }
		}
    ],
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609		
    Vue.nextTick(() => {
        document.title = to.meta.title;
    });
});

export default router;